export default __webpack_public_path__ + "media/images/logos/plus-divide-green-plus-ed9dc670aca87bb002dfa890456e8b8a.svg";